if (!customElements.get('delivery-date')) {
  class DeliveryDate extends HTMLElement {
    
    constructor() {
      super();
      
      this.cutOffTime = new Date(this.dataset.cutOffTime).getTime();
      if (!Number(this.cutOffTime)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.excludeHolidays = this.dataset.excludeHolidays === "true";
      if (Shopify.locale.indexOf("-") >= 0) {
        this.locale = Shopify.locale;
      } else {
        this.locale = Shopify.locale + '-' + Shopify.country;
      }

      this.addListeners();
      // Monitor ONLY the country attribute change in cart-samples element
      this.observer.observe(this, { attributes: true, attributeFilter: ['data-country'] });
      
      this.updateDeliveryDate();
    }

    updateDeliveryDate() {
      
      this.country = this.dataset.country;
      
      if (this.excludeHolidays) {
        
        // Fetch holidays for store country and destination country
        const countryCodes = [theme.settings.shopCountry, this.country];

        this.fetchHolidayDates(countryCodes)
          .then(holidayDates => {
              this.storeHolidays = holidayDates[0];
              this.destinationHolidays = holidayDates[1];

              this.querySelector('.date').innerText = this.addWorkingDays();  // Wait until the holidays are loaded
          })
          .catch(error => console.error(error));
      }
      else {
        
        this.querySelector('.date').innerText = this.addWorkingDays();  
      
      }
    }

    disconnectedCallback() {
      this.removeListeners();
    }

    addListeners() {
      this.observer = new MutationObserver(this.onCountryChanged.bind(this));
    }

    removeListeners() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    /**
     * Gets the delivery time for each destination country.
     * @returns {?object}
     */
    getDeliveryTimesData() {
      if (typeof this.deliveryTimesData === 'undefined') {
        const dataEl = this.querySelector('.js-data-delivery-times');
        if (dataEl) {
          this.deliveryTimesData = JSON.parse(dataEl.textContent);
        } else {
          this.deliveryTimesData = false;
        }
      }
  
      return this.deliveryTimesData;
    }

    addWorkingDays() {

      const delivery_zone = this.getDeliveryTimesData().countries[this.country];
      let deliveredDate = new Date(this.cutOffTime);
      let daysToAdd = delivery_zone ? delivery_zone.days : this.getDeliveryTimesData().countries['*'].days;
      let utc_offset = delivery_zone ? delivery_zone.utc_offset : "+0000"; // set timezone difference for destination country

      while (daysToAdd > 0) {

        // Format the date in YYYY-MM-DD format so to check against store's holidays
        let deliveredDateShopTZ = `${deliveredDate.getFullYear()}-${(deliveredDate.getMonth() + 1).toString().padStart(2, '0')}-${deliveredDate.getDate().toString().padStart(2, '0')}`;

        // Use toLocaleString to format in YYYY-MM-DD format with destination country time zone so to check against destination country's holidays
        const options = {
          timeZone: utc_offset, // Change to destination country time zone
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        let deliveredDateDestTZ = deliveredDate.toLocaleDateString('en-CA', options); // 'en-CA' uses the yyyy-mm-dd format natively

        // Check if the current day is a weekday and not public holidays in both store and destination country
        let dayOfWeek = deliveredDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6 
            && !(this.excludeHolidays && this.storeHolidays && this.storeHolidays.includes(deliveredDateShopTZ)) 
            && !(this.excludeHolidays && this.destinationHolidays && this.destinationHolidays.includes(deliveredDateDestTZ))) {
          daysToAdd--;
        }

        // Add a day
        deliveredDate.setDate(deliveredDate.getDate() + 1);
      }

      // Use toLocaleString with the desired time zone
      const options = {
          timeZone: utc_offset,
          month: 'short',
          day: 'numeric',
          weekday: 'short'
      }; 
      return deliveredDate.toLocaleString(this.locale, options);
    }

    fetchHolidayDates(countryCodes) {
      const year = new Date().getFullYear();
      const promises = countryCodes.map(countryCode => {
          const cacheKey = `holidayDates_${countryCode}_${year}`;
          const cachedData = localStorage.getItem(cacheKey);
  
          // Check if there's valid cached data for the current year
          if (cachedData) {
              const parsedData = JSON.parse(cachedData);
              if (parsedData.year === year) {
                  // console.log(`Using cached holiday dates for ${countryCode} for year:`, year);
                  return Promise.resolve(parsedData.holidayDates);
              } else {
                  // console.log(`Cached data for ${countryCode} is from a different year, refetching...`);
                  localStorage.removeItem(cacheKey); // Clear outdated data
              }
          }
  
          // Fetch new data if no valid cache exists
          const url = `https://date.nager.at/api/v3/publicholidays/${year}/${countryCode}`;
          return fetch(url)
              .then(response => {
                  if (!response.ok) {
                      throw new Error(`Network response was not ok for ${countryCode}`);
                  }
                  return response.json();
              })
              .then(holidays => {
                  // console.log(`Fetched new holiday dates for ${countryCode} for year:`, year);
                  // Extract only the dates from the holiday data
                  const holidayDates = holidays.map(holiday => holiday.date);
                  // Cache the new data with the year
                  const dataToCache = {
                      year: year,
                      holidayDates: holidayDates
                  };
                  localStorage.setItem(cacheKey, JSON.stringify(dataToCache));
                  return holidayDates;
              })
              .catch(error => {
                  console.error(`Failed to fetch holiday dates for ${countryCode}:`, error);
                  // throw error;
              });
      });
  
      return Promise.all(promises);
    }

    onCountryChanged(mutations) {
        mutations.forEach(mutation => {
          if (mutation.type === "attributes" && mutation.attributeName === 'data-country') {
            this.updateDeliveryDate();
          }
        });
    }
    
  }

  customElements.define('delivery-date', DeliveryDate);
}